<template>
    <on-click-outside :do="onClickOutside">
        <div class="map-button-round">
            <button v-if="backgroundLayers && backgroundLayers.length"
                    class="button is-info is-outlined"
                    @click="activate"
                    title="Картографическая основа"
                    :class="{'is-active' : isActive}">
            <span class="icon">
                <img v-if="isActive" src="../../../assets/svg/background-layers-button-active.svg"/>
                <img v-else src="../../../assets/svg/background-layers-button.svg"/>
            </span>
            </button>
            <right-panel v-show="isActive">
                <div class="box background-layers-panel">
                    <p class="is-text has-text-grey background-layers-panel-header">Картографическая основа</p>
                    <div class="columns is-multiline is-mobile">
                        <div class="column" v-for="backgroundLayer in backgroundLayers" :key="backgroundLayer.id" @click="setActiveBackgroundLayer(backgroundLayer)" :title="backgroundLayer.name">
                            <figure class="image" :class="{'active': isLayerActive(backgroundLayer)}">
                                <img :src="getIconUri(backgroundLayer)" alt=""/>
                            </figure>
                            <p class="is-text background-layer-name">{{backgroundLayer.name}}</p>
                        </div>
                    </div>
                </div>
            </right-panel>
        </div>
    </on-click-outside>
</template>
<script>
	import {mapActions, mapState} from "vuex";
	import RightPanel from "../RightPanel";
	import OnClickOutside from "../../common/OnClickOutside";


	export default {
		components: {
			RightPanel,
			OnClickOutside
		},
		data() {
			return {
				isActive: false
			};
		},
		methods: {
			...mapActions([
				'setActiveBackgroundLayer'
			]),
			getIconUri(backgroundLayer) {
				return require('../../../assets/background-layers/' + backgroundLayer.image);
			},
			isLayerActive(backgroundLayer) {
				return this.activeBackgroundLayer && backgroundLayer && this.activeBackgroundLayer.id === backgroundLayer.id;
			},
			activate() {
				this.isActive = !this.isActive;
				this.$emit('activated', this);
			},
			onClickOutside() {
				this.isActive = false;
			}
		},
		computed: {
			...mapState([
				'mapConfig',
				'activeBackgroundLayer'
			]),
			backgroundLayers() {
				return this.mapConfig.backgroundLayers;
			},
		}
	};
</script>
<style scoped lang="scss">
    @import '../../../assets/sass/main.scss';

    .background-layers-panel {
        width: 250px !important;
        padding: 15px 20px 15px 20px;
    }

    .background-layers-panel .columns {
        margin: 0 -15px -6px 0 !important; //компенсируем отступы у column ниже
    }


    .background-layers-panel .column {
        padding: 0 15px 6px 0 !important;
    }

    .background-layers-panel .image {
        width: 60px !important;
    }

    .background-layers-panel .image img {
        height: 54px;
        width: 54px;
    }

    .background-layers-panel .image.active img {
        border: solid 2px $cyan;
    }

    .background-layers-panel-header {
        margin-bottom: 9px;
    }

    .background-layer-name {
        max-width: 60px;
        font-size: 13px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: black;
    }
</style>
